function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M24.89 7.2L17.8.11a.757.757 0 0 0-.7-.206.757.757 0 0 0-.551.48 6.355 6.355 0 0 0-.25 3.48L9.186 10.13c-3.687-1.386-6.6.648-6.725.737a.759.759 0 0 0-.096 1.157l4.484 4.622-6.85 7.818a.38.38 0 1 0 .538.537l7.61-7.127 4.83 4.76a.758.758 0 0 0 1.157-.096c.09-.125 2.117-3.048.736-6.724l6.268-7.114a6.342 6.342 0 0 0 3.48-.25.757.757 0 0 0 .478-.55.757.757 0 0 0-.205-.7z"
})));

var SvgPinBlack = function SvgPinBlack(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPinBlack, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pin_black.52bbcdd3.svg";
export { ForwardRef as ReactComponent };